export default __webpack_public_path__ + "static/media/homepage-info-icon.9d93a858.svg";